import getLogger from '@ignitesales/logger-es';
import React from 'react';
import {connect} from 'react-redux';
import {answerChanged} from '../../actions/question-action-creators.mjs';
import PropTypes from 'prop-types';
import {QuestionShape} from '../../shapes/index.mjs';

const logger = getLogger({component: 'Question'});

function Question({component: Component, question, valueChanged, ...rest}) {
  const onValueChange = value => {
    if (question?.attributes?.valueChanged) {
      question.attributes.valueChanged({value, valueChanged});
    } else {
      valueChanged(value);
    }
  };

  return <Component {...rest} question={question} valueChanged={onValueChange} />;
}

Question.propTypes = {
  component: PropTypes.any,
  question: QuestionShape,
  valueChanged: PropTypes.any,
};

export default connect(
  ({answers}, {question: {appkey}}) => {
    const value = answers[appkey] || [];

    return {
      value,
    };
  },
  (dispatch, {question, questionGroup, page}) => {
    return {
      valueChanged: value => {
        logger.debug('valueChange() page object', page);
        const finalValue = typeof value === 'string' ? [value] : value;
        const calculatedQuestions = (page.questionGroups || []).reduce((list, currentGroup) => {
          return list.concat(currentGroup.questions.filter(q => q.type.toLowerCase() === 'calculated'));
        }, []);
        dispatch(
          answerChanged({
            question,
            questionGroup,
            value: finalValue,
            calculatedQuestions,
          })
        );
      },
    };
  }
)(Question);
